module.exports = __webpack_public_path__ + "img/FenXiang.9dbc0e58.svg";